import React, { useRef } from "react";
import Slider from 'react-slick'
import test_1 from '../../../assets/images/testimonial/testimonial-image-two.png'
import test_2 from '../../../assets/images/testimonial/teshtimonial-three-1.png'
import test_3 from '../../../assets/images/testimonial/testiomonial-four-1.png'
import test_4 from '../../../assets/images/testimonial/testimonial-image-two.png'
import test_qote from '../../../assets/images/svg/testimonial/qote-2.svg';
import test_arrowleft from '../../../assets/images/svg/arrow-left.svg';
import test_arrowright from '../../../assets/images/svg/arrow-right.svg';

const Testimonial = () => {
    const mainSliderRef = useRef(null);
    const thumbSliderRef = useRef(null);

    const testSlider1 = {
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        prevArrow: (
            <button type="button" className="slick-prev">
                <img src={test_arrowleft} alt="prev-icon" />
            </button>
        ),
        nextArrow: (
            <button type="button" className="slick-next">
                <img src={test_arrowright} alt="next-icon" />
            </button>
        ),
        asNavFor: thumbSliderRef.current,
    };

    const testSlider2 = {
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: false,
        arrows: false,
        asNavFor: mainSliderRef.current,
    }
    return (
        <>
            <div className="testimonial-section-two">
                <div className="container">
                    <div className="testimonial-section-inner-two">
                        <Slider ref={mainSliderRef} className="testimonial-slider-two" {...testSlider1}>
                            <div className="testimonial-item-two">
                                <div className="testimonial-box-two">
                                    <div className="testimonial-details-two">
                                        <img src={test_qote} alt="icon" />
                                        <p>
                                            Vulputate mi sit amet mauris commodo quis imperdiet.{" "}
                                            <span>Metus vulputate eu</span>
                                            felis imperdiet proin nulla aliquet enim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="testimonial-item-two">
                                <div className="testimonial-box-two">
                                    <div className="testimonial-details-two">
                                        <img src={test_qote} alt="icon" />
                                        <p>
                                            Vulputate mi sit amet mauris commodo quis imperdiet.{" "}
                                            <span>Metus vulputate eu</span>
                                            felis imperdiet proin nulla aliquet enim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="testimonial-item-two">
                                <div className="testimonial-box-two">
                                    <div className="testimonial-details-two">
                                        <img src={test_qote} alt="icon" />
                                        <p>
                                            Vulputate mi sit amet mauris commodo quis imperdiet.{" "}
                                            <span>Metus vulputate eu</span>
                                            felis imperdiet proin nulla aliquet enim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="testimonial-item-two">
                                <div className="testimonial-box-two">
                                    <div className="testimonial-details-two">
                                        <img src={test_qote} alt="icon" />
                                        <p>
                                            Vulputate mi sit amet mauris commodo quis imperdiet.{" "}
                                            <span>Metus vulputate eu</span>
                                            felis imperdiet proin nulla aliquet enim.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Slider>
                        <Slider ref={thumbSliderRef} className="testimonial-slider-thumb" {...testSlider2}>
                            <div className="testimonial-thumb-item">
                                <div className="testimonial-image-two">
                                    <img
                                        src={test_1}
                                        alt="testimonial-image"
                                    />
                                </div>
                            </div>
                            <div className="testimonial-thumb-item">
                                <div className="testimonial-image-two">
                                    <img
                                        src={test_2}
                                        alt="testimonial-image"
                                    />
                                </div>
                            </div>
                            <div className="testimonial-thumb-item">
                                <div className="testimonial-image-two">
                                    <img
                                        src={test_3}
                                        alt="testimonial-image"
                                    />
                                </div>
                            </div>
                            <div className="testimonial-thumb-item">
                                <div className="testimonial-image-two">
                                    <img
                                        src={test_4}
                                        alt="testimonial-image"
                                    />
                                </div>
                            </div>
                        </Slider>
                    </div>
                </div>
            </div>


        </>
    )
}

export default Testimonial
